/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsIdleSystemResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsIdleSystemResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsIdleSystemResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsIdleSystemResource>): RecommendationForFinopsIdleSystemResource {
        let obj = Object.assign(new RecommendationForFinopsIdleSystemResource(), model);
        RecommendationForFinopsIdleSystemResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsIdleSystemResource>): RecommendationForFinopsIdleSystemResource {
        if (!model) return null;
        return RecommendationForFinopsIdleSystemResource.newInstance(<RecommendationForFinopsIdleSystemResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsIdleSystemResource) {
        if (!obj) return;

        models.RecommendationForFinopsIdleSystemResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsIdleSystemResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsIdleSystemResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
